/* ALVETTA: あんしんお届けサポートの自動追加とカート内アップセル */
(function () {
  if (window.__alvAssureInit) return;
  window.__alvAssureInit = true;

  var ASSURE_ID = 67791867543625;
  var CARE_TYPE = 'シューケア用品';
  var busy = false;

  function root() { return window.Shopify && Shopify.routes ? Shopify.routes.root : '/'; }

  function getCart() {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function drawer() { return document.querySelector('cart-drawer'); }

  function sectionIds() {
    var d = drawer();
    if (d && typeof d.getSectionsToRender === 'function') {
      return d.getSectionsToRender().map(function (s) { return s.id; });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function render(sections) {
    var d = drawer();
    if (d && typeof d.renderContents === 'function' && sections) {
      d.renderContents({ id: ASSURE_ID, sections: sections });
    } else {
      window.location.reload();
    }
  }

  function setPref(value) {
    return fetch(root() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { _alv_assure: value } })
    });
  }

  function addAssure() {
    return fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: ASSURE_ID, quantity: 1 }], sections: sectionIds() })
    }).then(function (r) { return r.json(); });
  }

  function removeAssure() {
    return fetch(root() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: String(ASSURE_ID), quantity: 0, sections: sectionIds() })
    }).then(function (r) { return r.json(); });
  }

  function summarize(cart) {
    var assureQty = 0, shoes = 0;
    cart.items.forEach(function (item) {
      if (item.variant_id === ASSURE_ID) assureQty += item.quantity;
      else if (item.product_type !== CARE_TYPE) shoes += item.quantity;
    });
    return { assureQty: assureQty, shoes: shoes, pref: (cart.attributes || {})._alv_assure || '' };
  }

  function sync(source) {
    if (busy) return;
    busy = true;
    getCart().then(function (cart) {
      var s = summarize(cart);
      // 靴がなくなったらサポートも外す（サポート単体では購入できない）
      if (s.shoes === 0 && s.assureQty > 0) {
        return removeAssure().then(function (res) { render(res.sections); });
      }
      // サポートは1注文につき1つまで
      if (s.assureQty > 1) {
        return fetch(root() + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: String(ASSURE_ID), quantity: 1, sections: sectionIds() })
        }).then(function (r) { return r.json(); }).then(function (res) { render(res.sections); });
      }
      // 靴をカートに入れたとき、お客様が外していなければ自動で追加
      if (source === 'product-form' && s.shoes > 0 && s.assureQty === 0 && s.pref !== 'off') {
        return addAssure().then(function (res) { render(res.sections); });
      }
      // カート内でサポートの行を削除した場合は「外した」として記憶し、再追加しない
      if (source === 'cart-items' && s.shoes > 0 && s.assureQty === 0 && s.pref !== 'off') {
        return setPref('off');
      }
    }).catch(function () {}).then(function () { busy = false; });
  }

  function boot() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        sync(event && event.source);
      });
    }

    // あんしんお届けサポート：チェックボックスで付け外し
    document.addEventListener('change', function (e) {
      var box = e.target.closest('[data-alv-assure-toggle]');
      if (!box) return;
      if (busy) { box.checked = !box.checked; return; }
      busy = true;
      var label = box.closest('label');
      if (label) label.setAttribute('aria-busy', 'true');
      var job = box.checked ? setPref('on').then(addAssure) : setPref('off').then(removeAssure);
      job.then(function (res) { render(res.sections); })
        .catch(function () { window.location.reload(); })
        .then(function () { busy = false; });
    });

    // 2足目30%OFF：おすすめの1足をカートの靴と同じサイズで出す
    document.addEventListener('click', function (e) {
      var add = e.target.closest('[data-alv-pair-add], [data-alv-care-add]');
      if (add) { e.preventDefault(); addPair(add); return; }
      var next = e.target.closest('[data-alv-pair-next]');
      if (next) { e.preventDefault(); var box = next.closest('[data-alv-pair]'); box._alvIndex = (box._alvIndex || 0) + 1; drawPair(box); }
    });
    document.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-alv-pair-size]');
      if (!sel) return;
      var box = sel.closest('[data-alv-pair]');
      box._alvSize = sel.value;
      drawPair(box);
    });
    new MutationObserver(scanPairs).observe(document.body, { childList: true, subtree: true });
    scanPairs();
  }

  /* ---------- 2足目30%OFF のおすすめ ---------- */
  var recCache = {};

  function yen(cents) { return '¥' + Math.round(cents / 100).toLocaleString('ja-JP'); }
  function esc(t) { return String(t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function optIndex(product, word) {
    var names = (product.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    for (var i = 0; i < names.length; i++) if (names[i].indexOf(word) !== -1) return i;
    return -1;
  }

  function fetchRecs(productId) {
    if (!recCache[productId]) {
      recCache[productId] = fetch(root() + 'recommendations/products.json?product_id=' + productId + '&limit=10&intent=related')
        .then(function (r) { return r.json(); })
        .then(function (data) { return data.products || []; })
        .catch(function () { return []; });
    }
    return recCache[productId];
  }

  // そのサイズで買える候補だけを、安い順（2足目の割引がおすすめ側にかかる順）に並べる
  function candidates(box, products) {
    var exclude = (box.getAttribute('data-exclude') || '').split(',');
    var basePrice = Number(box.getAttribute('data-price')) || 0;
    var list = [];
    products.forEach(function (p) {
      if (!p.available || exclude.indexOf(String(p.id)) !== -1) return;
      if (p.handle === 'anshin-delivery-support' || p.type === CARE_TYPE) return;
      var sizeIdx = optIndex(p, 'サイズ');
      var insIdx = optIndex(p, 'インソール');
      var avail = p.variants.filter(function (v) { return v.available; });
      if (!avail.length) return;
      list.push({ p: p, sizeIdx: sizeIdx, insIdx: insIdx, avail: avail });
    });
    list.sort(function (a, b) {
      var ap = a.p.price <= basePrice ? 0 : 1, bp = b.p.price <= basePrice ? 0 : 1;
      return ap - bp;
    });
    return list;
  }

  function pickVariant(c, size, insole) {
    var vs = c.avail;
    if (c.sizeIdx !== -1 && size) {
      var bySize = vs.filter(function (v) { return v.options[c.sizeIdx] === size; });
      if (!bySize.length) return null;
      vs = bySize;
    }
    if (c.insIdx !== -1 && insole) {
      var byIns = vs.filter(function (v) { return v.options[c.insIdx] === insole; });
      if (byIns.length) vs = byIns;
    }
    return vs[0];
  }

  var sameCache = {};

  // カートに入っている靴そのもの（同じ靴をもう1足）
  function fetchSame(handle) {
    if (!handle) return Promise.resolve(null);
    if (!sameCache[handle]) {
      sameCache[handle] = fetch(root() + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return sameCache[handle];
  }

  function scanPairs() {
    var boxes = document.querySelectorAll('[data-alv-pair]:not([data-alv-ready])');
    Array.prototype.forEach.call(boxes, function (box) {
      box.setAttribute('data-alv-ready', '1');
      Promise.all([fetchSame(box.getAttribute('data-handle')), fetchRecs(box.getAttribute('data-product-id'))]).then(function (res) {
        var list = candidates(box, res[1]);
        var p = res[0];
        var avail = p && p.available ? p.variants.filter(function (v) { return v.available; }) : [];
        if (avail.length) {
          list.unshift({ p: p, sizeIdx: optIndex(p, 'サイズ'), insIdx: optIndex(p, 'インソール'), avail: avail, same: true });
        }
        box._alvList = list;
        drawPair(box);
      });
    });
  }

  function drawPair(box) {
    var list = box._alvList || [];
    var card = box.querySelector('[data-alv-pair-card]');
    var loading = box.querySelector('[data-alv-pair-loading]');
    var cartSize = box.getAttribute('data-size');
    var insole = box.getAttribute('data-insole');
    // 同じ靴をいちばん先に、ほかの靴はカートの靴と同じサイズが買えるものを優先
    var same = list.filter(function (c) { return c.same; });
    var others = list.filter(function (c) { return !c.same; });
    var ordered = same.concat(others.filter(function (c) { return pickVariant(c, cartSize, insole); }))
      .concat(others.filter(function (c) { return !pickVariant(c, cartSize, insole); }));
    if (!ordered.length) { box.hidden = true; return; }
    var c = ordered[(box._alvIndex || 0) % ordered.length];
    if (box._alvShown !== c.p.id) { box._alvShown = c.p.id; box._alvSize = null; }
    var size = box._alvSize || cartSize;
    var variant = pickVariant(c, size, insole);
    if (!variant) { size = ''; variant = pickVariant(c, '', insole); }

    var basePrice = Number(box.getAttribute('data-price')) || 0;
    var price = variant.price;
    var off = Math.round(Math.min(price, basePrice || price) * 0.3 / 100) * 100;
    var img = c.p.featured_image ? (String(c.p.featured_image).replace(/^\/\//, 'https://') + (String(c.p.featured_image).indexOf('?') === -1 ? '?' : '&') + 'width=200') : '';

    var sizeSelect = '';
    if (c.sizeIdx !== -1) {
      var sizes = [];
      c.avail.forEach(function (v) { var s = v.options[c.sizeIdx]; if (sizes.indexOf(s) === -1) sizes.push(s); });
      sizeSelect = '<select class="alv-pair__size" data-alv-pair-size aria-label="サイズ">' + sizes.map(function (s) {
        return '<option value="' + esc(s) + '"' + (s === variant.options[c.sizeIdx] ? ' selected' : '') + '>サイズ ' + esc(s) + '</option>';
      }).join('') + '</select>';
    }
    var name = String(c.p.title).split('（')[0];
    var msg = (cartSize && c.sizeIdx !== -1 && variant.options[c.sizeIdx] !== cartSize) ? '<p class="alv-pair__msg">お選びのサイズ（' + esc(cartSize) + '）は在庫がありません</p>' : '';

    card.innerHTML =
      (img ? '<img class="alv-pair__img" src="' + esc(img) + '" alt="" width="84" height="84" loading="lazy">' : '') +
      '<div class="alv-pair__info">' +
        '<p class="alv-pair__label">' + (c.same ? '同じ靴をもう1足' : 'ほかの靴と組み合わせる') + '</p>' +
        '<a class="alv-pair__name" href="' + esc(c.p.url) + '">' + esc(name) + '</a>' +
        '<p class="alv-pair__prices"><span class="alv-pair__was">' + yen(price) + '</span><span class="alv-pair__now">' + yen(price - off) + '</span><span class="alv-pair__tag">30%OFF</span></p>' +
        msg +
        '<div class="alv-pair__row">' + sizeSelect + (ordered.length > 1 ? '<button type="button" class="alv-pair__next" data-alv-pair-next>ほかの靴</button>' : '') + '</div>' +
        '<button type="button" class="alv-pair__add" data-alv-pair-add data-variant-id="' + variant.id + '">30%OFFでカートに追加</button>' +
      '</div>';
    card.hidden = false;
    if (loading) loading.hidden = true;
  }

  function addPair(btn) {
    if (busy) return;
    busy = true;
    btn.setAttribute('aria-busy', 'true');
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-variant-id')), quantity: 1 }], sections: sectionIds() })
    }).then(function (r) { return r.json(); })
      .then(function (res) { if (res.sections) render(res.sections); else window.location.reload(); })
      .catch(function () { window.location.reload(); })
      .then(function () { busy = false; });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
